import "babel-polyfill";
import "react-app-polyfill/ie9";
import "url-polyfill";

import "./css/main.scss";

// Core modules.
import React from "react";
window.React = React;
import ReactDOM from "react-dom";
window.ReactDOM = ReactDOM;
import ReactCreateClass from "create-react-class";
window.React.createClass = ReactCreateClass;
import ReactPropTypes from "prop-types";
window.React.PropTypes = ReactPropTypes;
import * as uuid from "uuid";
window.uuid = uuid;

// Routes file - created by Rails.
import Routes from "./js/generated/routes.js";
window.Routes = Routes;

// Studio UI
import StudioCampaignContentWrapper from "./js/components/studio/campaign_content_section/studio_campaign_content_wrapper.jsx";
window.StudioCampaignContentWrapper = StudioCampaignContentWrapper;
import SubscriberSearchContainer from "./js/components/studio/mailing_lists/subscriber_search/subscriber_search_container.jsx";
window.SubscriberSearchContainer = SubscriberSearchContainer;
import SuppressedAddressSearch from "./js/components/suppressed_address_search/component.jsx";
window.SuppressedAddressSearch = SuppressedAddressSearch;
import StudioOpensOverviewByPrivacy from "./js/components/studio/stats/studio_opens_overview_by_privacy.jsx";
window.StudioOpensOverviewByPrivacy = StudioOpensOverviewByPrivacy;

// Engine UI
import EuiUsersIndex from "@js/components/eui/users/index.jsx";
window.EuiUsersIndex = EuiUsersIndex;
import EuiUsersShow from "@js/components/eui/users/show.jsx";
window.EuiUsersShow = EuiUsersShow;
import EuiUsersForm from "@js/components/eui/users/form.jsx";
window.EuiUsersForm = EuiUsersForm;
import EuiRoutesIndex from "@js/components/eui/routes/index.jsx";
window.EuiRoutesIndex = EuiRoutesIndex;
import EuiRoutesShow from "@js/components/eui/routes/show.jsx";
window.EuiRoutesShow = EuiRoutesShow;
import EuiRoutesForm from "@js/components/eui/routes/form.jsx";
window.EuiRoutesForm = EuiRoutesForm;
import EuiDefaultBounceAddress from "@js/components/eui/incoming_email_domains/default_bounce_address.jsx";
window.EuiDefaultBounceAddress = EuiDefaultBounceAddress;
import EuiDefaultUrlDomain from "@js/components/eui/url_domains/default_url_domain.jsx";
window.EuiDefaultUrlDomain = EuiDefaultUrlDomain;
import EuiTwoFactorAuthenticationsForm from "@js/components/eui/two_factor_authentications/form.jsx";
window.EuiTwoFactorAuthenticationsForm = EuiTwoFactorAuthenticationsForm;
import QrCodeScanner from "./js/components/eui/two_factor_authentications/qr_code_scanner.jsx";
window.QrCodeScanner = QrCodeScanner;
import EuiTableOfReferences from "@js/components/eui/table_of_references.jsx";
window.EuiTableOfReferences = EuiTableOfReferences;
import EuiUserSettingsForm from "@js/components/eui/user_settings/form.jsx";
window.EuiUserSettingsForm = EuiUserSettingsForm;
import EuiUserSettingsShow from "@js/components/eui/user_settings/show.jsx";
window.EuiUserSettingsShow = EuiUserSettingsShow;
import EuiDiskQueueSummaryIndex from "@js/components/eui/disk_queue_summary/index.jsx";
window.EuiDiskQueueSummaryIndex = EuiDiskQueueSummaryIndex;
import EuiHomesShow from "@js/components/eui/homes/show.jsx";
window.EuiHomesShow = EuiHomesShow;
import EuiHelpIcon from "@js/components/eui/help_icon.jsx";
window.EuiHelpIcon = EuiHelpIcon;
import EuiLinkReplacementsIndex from "@js/components/eui/link_replacements/index.jsx";
window.EuiLinkReplacementsIndex = EuiLinkReplacementsIndex;
import EuiLinkReplacementsShow from "@js/components/eui/link_replacements/show.jsx";
window.EuiLinkReplacementsShow = EuiLinkReplacementsShow;
import EuiLinkReplacementsForm from "@js/components/eui/link_replacements/form.jsx";
window.EuiLinkReplacementsForm = EuiLinkReplacementsForm;
import EuiSearchBox from "@js/components/eui/search_box.jsx";
window.EuiSearchBox = EuiSearchBox;
import EuiVirtualMtaPausedDomainsIndex from "@js/components/eui/paused_domains/index.jsx";
window.EuiVirtualMtaPausedDomainsIndex = EuiVirtualMtaPausedDomainsIndex;
import EuiArchivedMessagesIndex from "@js/components/eui/archived_messages/index.jsx";
window.EuiArchivedMessagesIndex = EuiArchivedMessagesIndex;
import EuiArchivedMessagesShow from "@js/components/eui/archived_messages/show.jsx";
window.EuiArchivedMessagesShow = EuiArchivedMessagesShow;
import EuiSendingDomainsIndex from "@js/components/eui/sending_domains/index.jsx";
window.EuiSendingDomainsIndex = EuiSendingDomainsIndex;
import EuiSendingDomainsShow from "@js/components/eui/sending_domains/show.jsx";
window.EuiSendingDomainsShow = EuiSendingDomainsShow;
import EuiSendingDomainsForm from "@js/components/eui/sending_domains/form.jsx";
window.EuiSendingDomainsForm = EuiSendingDomainsForm;
import EuiSharedTrackingDomainsIndex from "@js/components/eui/shared_tracking_domains/index.jsx";
window.EuiSharedTrackingDomainsIndex = EuiSharedTrackingDomainsIndex;
import EuiSharedTrackingDomainsShow from "@js/components/eui/shared_tracking_domains/show.jsx";
window.EuiSharedTrackingDomainsShow = EuiSharedTrackingDomainsShow;
import EuiSharedTrackingDomainsForm from "@js/components/eui/shared_tracking_domains/form.jsx";
window.EuiSharedTrackingDomainsForm = EuiSharedTrackingDomainsForm;
import EuiReceivingDomainsIndex from "@js/components/eui/receiving_domains/index.jsx";
window.EuiReceivingDomainsIndex = EuiReceivingDomainsIndex;
import EuiReceivingDomainsShow from "@js/components/eui/receiving_domains/show.jsx";
window.EuiReceivingDomainsShow = EuiReceivingDomainsShow;
import EuiReceivingDomainsForm from "@js/components/eui/receiving_domains/form.jsx";
window.EuiReceivingDomainsForm = EuiReceivingDomainsForm;

// Monitor UI
import MuiCampaignsIndex from "./js/components/mui/campaigns/index.jsx";
window.MuiCampaignsIndex = MuiCampaignsIndex;
import MuiCampaignsShow from "./js/components/mui/campaigns/show.jsx";
window.MuiCampaignsShow = MuiCampaignsShow;
import MuiSubAccountsIndex from "./js/components/mui/sub_accounts/index.jsx";
window.MuiSubAccountsIndex = MuiSubAccountsIndex;
import MuiSubAccountsShow from "./js/components/mui/sub_accounts/show.jsx";
window.MuiSubAccountsShow = MuiSubAccountsShow;
import MuiSubAccountsForm from "./js/components/mui/sub_accounts/form.jsx";
window.MuiSubAccountsForm = MuiSubAccountsForm;
import MuiUserRolesShow from "./js/components/mui/user_roles/show.jsx";
window.MuiUserRolesShow = MuiUserRolesShow;
import MuiUserRolesForm from "./js/components/mui/user_roles/form.jsx";
window.MuiUserRolesForm = MuiUserRolesForm;
import MuiUserRolesIndex from "./js/components/mui/user_roles/index.jsx";
window.MuiUserRolesIndex = MuiUserRolesIndex;
import MuiRoleSelection from "./js/components/mui/role_selection.jsx";
window.MuiRoleSelection = MuiRoleSelection;
import MuiUserSettingsShow from "./js/components/mui/user_settings/show.jsx";
window.MuiUserSettingsShow = MuiUserSettingsShow;
import MuiUserSettingsForm from "./js/components/mui/user_settings/form.jsx";
window.MuiUserSettingsForm = MuiUserSettingsForm;
import MuiSeedListsIndex from "./js/components/mui/seed_lists/index.jsx";
window.MuiSeedListsIndex = MuiSeedListsIndex;
import MuiAlertsForm from "./js/components/mui/alerts/form.jsx";
window.MuiAlertsForm = MuiAlertsForm;
import MuiAlertsShow from "./js/components/mui/alerts/show.jsx";
window.MuiAlertsShow = MuiAlertsShow;
import MuiAlertsIndex from "./js/components/mui/alerts/index.jsx";
window.MuiAlertsIndex = MuiAlertsIndex;

// React mounter.

import GreenArrowReactMounter from "./js/green_arrow_react_mounter.js";
window.GreenArrowReactMounter = GreenArrowReactMounter;

/**
 * Setup Notifications Container
 */
if ( document.readyState === "loading" ) {
  document.addEventListener("DOMContentLoaded", (e) => {
    GreenArrowReactMounter.mountComponents();
  });
} else {
  GreenArrowReactMounter.mountComponents();
}
document.addEventListener("page:load", () => {
  GreenArrowReactMounter.mountComponents();
});
